module.exports = __webpack_public_path__ + "img/Frame-89.48fa4a4b.svg";